import { Button, Col, Row } from "antd";
import { useContext } from "react";
import { HiOutlinePencil } from "react-icons/hi";
import { CartContext } from "../../Contexts/CartContext";
import CartOrderSummary from "../CartOrderSummary/CartOrderSummary";
import { FloatingCartButton } from "../CartScreen/CartScreen";
import CartTable from "../CartScreen/CartTable";
import CartTableMobile from "../CartScreen/CartTableMobile";
import styles from "./ConfirmationScreen.module.scss";

const ConfirmationScreen = ({
  payload,
  setOrder,
  setStripeData,
  step,
  setStep,
  personal,
  shipping,
  deliveryDate,
  orderPlaceHandler,
}) => {
  const cartContext = useContext(CartContext);
  const { paymentMethod } = useContext(CartContext);

  return (
    <>
      <div className="container">
        <Row
          style={{ width: "100%" }}
          gutter={window.innerWidth > 576 ? [30, 30] : [0, 0]}
        >
          <Col lg={18} xs={24}>
            <div className={styles.title}>
              <span className={"text-dark fs-3 fw-bold"}>
                Personal / Billing Information
              </span>
              <HiOutlinePencil onClick={() => setStep(2)} size={15} />
            </div>

            <div className={styles.addr}>
              <em>
                {personal.title} {personal.first_name} {personal.last_name}
              </em>
              <span>
                {personal.house_no}, {personal.street_address}
              </span>
              <span>
                {personal.zip_code}, {personal.city}, {personal.state}
              </span>
              <span>E-mail: {personal.email}</span>
              {personal.phone_number && (
                <span>Tel: +49{personal.phone_number}</span>
              )}
            </div>
            <br />
            <div className={styles.title}>
              <span className={"text-dark fs-3 fw-bold"}>
                Shipping Information
              </span>
              <HiOutlinePencil onClick={() => setStep(2)} size={15} />
            </div>

            <div className={styles.addr}>
              <em>
                {shipping.title} {shipping.first_name} {shipping.last_name}
              </em>
              <span>
                {shipping.house_no}, {shipping.street_address}
              </span>
              <span>
                {shipping.zip_code}, {shipping.city}, {shipping.state}
              </span>
              <span>E-mail: {shipping.email}</span>
              {shipping.phone_number && (
                <span>Tel: +49{shipping.phone_number}</span>
              )}
            </div>

            {deliveryDate && (
              <>
                <br />
                <div className={styles.title}>
                  <span className={"text-dark fs-3 fw-bold"}>
                    Delivery Date
                  </span>
                  <HiOutlinePencil onClick={() => setStep(2)} size={15} />
                </div>

                <div className={styles.addr}>
                  <em>
                    {new Date(`${deliveryDate}T00:00:00`).toLocaleDateString(
                      "de-DE",
                      { weekday: "long", day: "numeric", month: "long", year: "numeric" },
                    )}
                  </em>
                  <span>Between 12:00 and 20:00</span>
                </div>
              </>
            )}

            <br />
            <div className={styles.title + " mb_only"}>
              <span className={"fw-bold"}>Payment Summary</span>
            </div>

            <div className={styles.calc_bd + " mb_only"}>
              <div className={styles.summary_item}>
                <span>Sub Total Article Price (Excl. VAT)</span>
                <span style={{ color: "var(--color-dark)", fontSize: "20px" }}>
                  {parseFloat(
                    cartContext.calculateOrderSubTotalExclVat(),
                  ).toFixed(2)}{" "}
                  €
                </span>
              </div>

              <div className={styles.summary_item}>
                <span>Articles</span>
                <span style={{ color: "var(--color-dark)" }}>
                  ({cartContext.cartItems.length})
                </span>
              </div>

              <div className={styles.summary_item}>
                <span>Weight(≈)</span>
                <span style={{ color: "var(--color-dark)" }}>
                  {cartContext.getTotalCartWeight()} kg
                </span>
              </div>

              <div className={styles.summary_item}>
                <span>Standard Delivery</span>
                <span style={{ color: "var(--color-dark)" }}>
                  {cartContext.deliveryCharge} €
                </span>
              </div>

              <hr />

              <div className={styles.summary_item}>
                <span>Net amount (Incl. VAT)</span>
                <span style={{ color: "var(--color-dark)" }}>
                  {parseFloat(
                    cartContext.calculateOrderSubTotal() +
                      cartContext.deliveryCharge,
                  ).toFixed(2)}{" "}
                  €
                </span>
              </div>

              <div className={styles.summary_item}>
                <span>
                  VAT A - 7% ({cartContext.getArticleACount()} articles)
                </span>
                <span style={{ color: "var(--color-dark)" }}>
                  {parseFloat(cartContext.calculateVatA()).toFixed(2)} €
                </span>
              </div>

              <div className={styles.summary_item}>
                <span>
                  VAT B - 19% ({cartContext.getArticleBCount()} articles)
                </span>
                <span style={{ color: "var(--color-dark)" }}>
                  {parseFloat(cartContext.calculateVatB()).toFixed(2)} €
                </span>
              </div>

              <hr />

              <div className={styles.summary_item}>
                <span
                  className={"fs-2 fw-bold"}
                  style={{ color: "var(--color-dark)" }}
                >
                  Total Price <span>(Incl. VAT)</span>
                </span>
                <span
                  className={"fw-bold"}
                  style={{ color: "var(--color-dark)", fontSize: "20px" }}
                >
                  {cartContext.calculateOrderTotal()} €
                </span>
              </div>

              {cartContext.saved === "0.00" ? null : (
                <div
                  style={{
                    backgroundColor: "var(--color-primary)",
                    textAlign: "center",
                    padding: "5px 0",
                    color: "#fff",
                  }}
                >
                  You saved {cartContext.saved} EUR with Desi Fresh
                </div>
              )}

              {cartContext.calculateOrderSubTotal() > 49 && (
                <Button
                  type={"primary"}
                  style={{ width: "100%", borderRadius: 0 }}
                  className={`${styles.free_ship} mt-3`}
                >
                  <img src="/icon/checkout/free-ship.svg" alt="" />
                  Congrats! You've earned free shipping
                </Button>
              )}

              <div className={styles.secure + " dt_only"}>
                <img src="/icon/checkout/lock.svg" alt="" />
                <span>Secure Payment Guaranteed</span>
              </div>
            </div>

            <br />
            <div className={styles.title}>
              <span className={"fw-bold"}>Payment Method</span>
              <HiOutlinePencil onClick={() => setStep(3)} size={15} />
            </div>
            <div className={styles.pm}>
              {paymentMethod === "card" ? (
                <img
                  src={
                    window.innerWidth > 576
                      ? "https://desi-fresh.b-cdn.net/misc/dekstop-card-pm.svg"
                      : "/icon/checkout/pm_1_long.svg"
                  }
                  alt=""
                />
              ) : paymentMethod === "paypal" ? (
                <img src="/icon/checkout/pm_3.svg" alt="" />
              ) : paymentMethod === "giropay" ? (
                <img
                  src="https://desi-fresh.b-cdn.net/components_static/Giropay.svg"
                  alt=""
                />
              ) : paymentMethod === "apple-google" ? (
                <img src="/icon/checkout/pm_4.svg" alt="" />
              ) : paymentMethod === "sofort" ? (
                <img src="/icon/checkout/pm_5.svg" alt="" />
              ) : (
                <img src="/icon/checkout/pm_2.svg" alt="" />
              )}
            </div>

            <br />

            <div className={styles.title}>
              <span className={"fw-bold"}>Cart Items</span>
              <HiOutlinePencil onClick={() => setStep(1)} size={15} />
            </div>
            <div className={styles.cart_table_wrapper}>
              <CartTable />
            </div>
            <div className={styles.cart_table_mobile}>
              <CartTableMobile />
            </div>
          </Col>
          <Col xs={0} lg={6}>
            <CartOrderSummary
              cartContext={cartContext}
              step={step}
              setStep={step}
              orderPlaceHandler={orderPlaceHandler}
            />
          </Col>
          <FloatingCartButton
            setStep={setStep}
            step={step}
            orderPlaceHandler={orderPlaceHandler}
          />
        </Row>
      </div>
    </>
  );
};

export default ConfirmationScreen;
